module.exports = __webpack_public_path__ + "img/blue-car.85f4bd56.svg";